export default __webpack_public_path__ + "static/2_multiply-fc9329ea985106ec76f7e486fb53c5b5.png";